import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  age: number;
  product: string;
  time: string;
}
const purchases: Purchase[] = [{
  name: 'Julieta',
  city: 'La Plata',
  age: 38,
  product: 'Mente en Calma',
  time: 'hace 4 minutos'
}, {
  name: 'Fernanda',
  city: 'Santa Fe',
  age: 45,
  product: 'Noche en Paz · Edición Completa',
  time: 'hace 7 minutos'
}, {
  name: 'Noelia',
  city: 'San Miguel de Tucumán',
  age: 34,
  product: 'Mente en Calma',
  time: 'hace 10 minutos'
}, {
  name: 'Carolina',
  city: 'Bahía Blanca',
  age: 42,
  product: 'Noche en Paz · Edición Completa',
  time: 'hace 3 minutos'
}, {
  name: 'Lorena',
  city: 'Posadas',
  age: 36,
  product: 'Mente en Calma',
  time: 'hace 6 minutos'
}, {
  name: 'Rocío',
  city: 'Neuquén',
  age: 40,
  product: 'Noche en Paz · Edición Completa',
  time: 'hace 9 minutos'
}, {
  name: 'Marcela',
  city: 'Resistencia',
  age: 39,
  product: 'Mente en Calma',
  time: 'hace 5 minutos'
}];
const FIRST_DELAY = 5000;
const INTERVAL = 10000;
const VISIBLE_DURATION = 4000;
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const indexRef = useRef(0);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    let cycleInterval: ReturnType<typeof setInterval>;
    const showOne = () => {
      setIndex(indexRef.current);
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        indexRef.current = (indexRef.current + 1) % purchases.length;
      }, VISIBLE_DURATION);
    };
    const firstTimeout = setTimeout(() => {
      showOne();
      cycleInterval = setInterval(showOne, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      clearTimeout(firstTimeout);
      clearTimeout(hideTimeout);
      clearInterval(cycleInterval);
    };
  }, []);
  const current = purchases[index];
  return <AnimatePresence data-id="element-243">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -40,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} role="status" aria-live="polite" className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-[60] max-w-[320px] w-[calc(100%-2rem)] sm:w-auto" data-id="element-244">
          <div className="bg-white border-l-4 rounded-lg shadow-xl py-3 pl-4 pr-5 flex items-start gap-3" style={{
        borderLeftColor: '#7C3AED',
        fontFamily: 'sans-serif',
        color: '#333'
      }} data-id="element-245">
            <div className="flex-shrink-0 mt-0.5 text-xl" aria-hidden="true" data-id="element-246">
              🛒
            </div>
            <div className="text-sm leading-snug" data-id="element-247">
              <p data-id="element-248">
                <span className="font-semibold" data-id="element-249">{current.name}</span> de{' '}
                {current.city}, {current.age} años, compró:{' '}
                <span className="font-semibold" data-id="element-250">“{current.product}”</span>
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-251">{current.time}</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}